import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';


function ErrorFallback() {
    const { i18n } = useTranslation();
    const [timeLeft, setTimeLeft] = useState(59); // in seconds
    const [isCounting, setIsCounting] = useState(true);
    const timerRef = useRef(null);

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60)
        .toString()
        .padStart(2, "0");
        const secs = (seconds % 60).toString().padStart(2, "0");
        return `${mins}:${secs}`;
    };

    useEffect(() => {
        if (isCounting && timeLeft > 0) {
        timerRef.current = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);
        }

        return () => clearInterval(timerRef.current);
    }, [isCounting]);

    useEffect(() => {
        if (timeLeft <= 0) {
        setIsCounting(false);
        clearInterval(timerRef.current);
        }
    }, [timeLeft]);

     const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <Box
        sx={{
            minHeight: 80,
            width: '100%',
            maxWidth: 700,
            mx: 'auto',
            textAlign: "center",
            borderRadius: "8px",
            color: "#333",
            direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
            fontFamily: i18n.language === 'ar' ? `'Cairo', sans-serif` : 'inherit',
        }}
        >
        { i18n.language === 'ar' ? (
            <>
                {isCounting ? (
                <>
                    <Typography
                    color="error"
                    variant="body2"
                    sx={{ fontSize: '15px'}}
                    >
                    يرجى الانتظار لبضع دقائق قبل تحديث الصفحة.<br />
                    إذا استمرت المشكلة، يرجى التواصل مع فريق بسمة.
                    </Typography>
                    <Button
                    className="refresh-button"
                    onClick={handleRefresh}
                    disabled={isCounting}
                    zIndex={1000}
                    sx={{ mt: 2 }} 

                    >
                    {formatTime(timeLeft)}
                    </Button>
                </>
                ) : (
                <Button
                    className="refresh-button"
                    onClick={handleRefresh}
                    disabled={isCounting}
                    zIndex={1000}
                    fontSize="15px"
                >
                    تحديث
                </Button>
                )}
            </>
            ) : (
            <>
                {isCounting ? (
                    <>
                     <Typography
                    color="error"
                    variant="body2"
                    sx={{ fontSize: '15px'}}
                >
                    Please wait a few minutes before refreshing the page.<br />
                    If the problem persists, contact our support team.
                </Typography>

                <Button
                    className="refresh-button"
                    onClick={handleRefresh}
                    disabled={isCounting}
                    zIndex={1000}
                    sx={{ mt: 2}} // spacing when timer active
                >
                    {formatTime(timeLeft)}
                </Button>
                </>
                ) : (
                <Button
                    className="refresh-button"
                    onClick={handleRefresh}
                    disabled={isCounting}
                    zIndex={1000}
                   
                >
                    Refresh
                </Button>
                )}


            </>
        )}
        </Box>

        )
    }

export default ErrorFallback;
